import { Injectable } from '@angular/core';
import { Headers, Http, Response } from '@angular/http';
import 'rxjs/Rx';
import { Globals } from '../globals';

@Injectable()
export class ActivitiesService {

    constructor(private http: Http) {

    }

    postActivity(activity: any) {
        const newActivity = JSON.stringify(activity);
        const headers = new Headers({
            'Content-Type': 'application/json'
        });

        return this.http.post(Globals.ACTIVITIES_COLLECTION_URL, newActivity, {headers}).map(res => {
            console.log(res.json());
            return res.json();
        });
    }

    getActivities() {
        return this.http.get(Globals.ACTIVITIES_COLLECTION_URL).map(res => res.json());
    }

    getActivity(id$: string) {
        const activityUrl = `${Globals.ACTIVITY_DOCUMENT_URL}/${id$}.json`;

        return this.http.get(activityUrl).map(res => res.json());
    }

    putActivity(activity: any, id$: string) {
        const newActivity = JSON.stringify(activity);
        const headers = new Headers({
            'Content-Type': 'application/json'
        });
        const activityUrl = `${Globals.ACTIVITY_DOCUMENT_URL}/${id$}.json`;

        return this.http.put(activityUrl, newActivity, {headers}).map(res => {
            console.log(res.json());
            return res.json();
        });
    }

    delActivity(id$: string) {
        const activityUrl = `${Globals.ACTIVITY_DOCUMENT_URL}/${id$}.json`;

        return this.http.delete(activityUrl).map(res => res.json());
    }

}
